<template>
    <div class="slick-slider">
        <slick ref="slick" :options="slickOptions">
            <template v-for="(item, index) in related">
                <figure class="figure">
                    <router-link class="projects__link" :to="{name: 'project_details', params: {slug: item.slug}}">
                        <img class="w-100" :src="item.main_image.thumb1" :alt="item.title"/>
                    </router-link>
                    <figcaption class="figure-caption">
                        <h4>{{item.title}}</h4>
                        <div>{{item.subject}}</div>
                        <span class="badge badge-danger ml-2" v-for="v in item.tags">#{{v.name}}</span>
                    </figcaption>
                </figure>
            </template>
        </slick>
    </div>
</template>

<script>
    import Slick from 'vue-slick';
    export default {
        name: "RelatedProjects",
        components: {
            Slick
        },
        props: ['related'],
        data () {
            return {
                slickOptions: {
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: false,
                    arrows: true,
                    touchThreshold: 100,
                    swipeToSlide: true,
                    useTransform: false,
                    speed: 200,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 520,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                },
            }
        },
        beforeUpdate() {
            if (this.$refs.slick) {
                this.$refs.slick.destroy();
            }
        },
        updated() {
            this.$nextTick(function () {
                if (this.$refs.slick) {
                    this.$refs.slick.create(this.slickOptions);
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/RelatedProjects.vue